import axios, { AxiosResponse } from 'axios'

import {
	BattleshipCompetitorResponse,
	BattleshipCompetitorResponseResponse,
	BattleshipPrompt,
	BattleshipPromptResponse,
	BattleshipResponse,
	BattleshipResponseCompetitor,
	BattleshipResponseCompetitorResponse,
	BattleshipResponseResponse,
	BuildingBlocksPrompt,
	BuildingBlocksPromptResponse,
	ConnectFourResponse,
	ConnectFourResponseResponse,
	DressUpPromptRequest,
	DressUpPromptResponse,
	DressUpResponse,
	DressUpResponseResponse,
	ImageResponse,
	MusicalChairsPrompt,
	MusicalChairsPromptResponse,
	MusicalChairsResponse,
	MusicalChairsResponseResponse,
	OppositeDayPrompt,
	OppositeDayPromptResponse,
	ProcessImageRequest,
	RoundRobinPrompt,
	RoundRobinPromptResponse,
	RoundRobinResponse,
	RoundRobinResponseResponse,
	SimonSaysAiIdeasResponseInput,
	SimonSaysExampleIdeaResponse,
	SimonSaysPromptResponse,
	SimonSaysPrompts,
	SimonSaysResponse,
	SlotMachinePrompt,
	SlotMachinePromptResponse,
	SlotMachineResponse,
	SlotMachineResponseResponse,
	TeeterTotterResponse,
	TeeterTotterResponseResponse,
	UpdateDressUpAdviceRequest,
	UpdateRoundRobinPromptsRequest,
	UpdateTeeterTotterAdviceRequest,
} from '../models/ideaModels'
import { getSignedRequest } from '../utils/authUtils'

export const postSlotMachinePrompt = async (
	data: SlotMachinePrompt
): Promise<SlotMachinePromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/slotMachinePrompt',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/slotMachinePrompt',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postProcessImage = async (
	data: ProcessImageRequest
): Promise<ImageResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/processImage',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/processImage',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postSimonSaysResponse = async (data: SimonSaysResponse) => {
	const signed = await getSignedRequest(
		'POST',
		'ai/simonSaysResponse',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/simonSaysResponse',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postSlotMachineResponse = async (
	data: SlotMachineResponse
): Promise<SlotMachineResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/slotMachineResponse',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/slotMachineResponse',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const getPromptResponse = async (
	aiPrompt: string
): Promise<AxiosResponse> => {
	// convert to json for now
	const data = {
		aiPrompt,
	}
	const signed = await getSignedRequest(
		'POST',
		'ai/process-chat-prompt',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/process-chat-prompt',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postBattleshipPrompt = async (
	data: BattleshipPrompt
): Promise<BattleshipPromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/battleShipsPrompt',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/battleShipsPrompt',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postBattleshipResponse = async (
	data: BattleshipResponse
): Promise<BattleshipResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/battleShipsResponse',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/battleShipsResponse',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postBattleshipCompetitorResponse = async (
	data: BattleshipCompetitorResponse
): Promise<BattleshipCompetitorResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/battleShipsCompetitor',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/battleShipsCompetitor',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postBattleshipResponseToCompetitor = async (
	data: BattleshipResponseCompetitor
): Promise<BattleshipResponseCompetitorResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/battleShipsResponseCompetitor',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/battleShipsResponseCompetitor',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postConnectFourResponse = async (
	data: ConnectFourResponse
): Promise<ConnectFourResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/connectFourResponse',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/connectFourResponse',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}
// This returns the data that populates Section2 of the game
export const postDressUpPrompt = async (
	data: DressUpPromptRequest
): Promise<DressUpPromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/dressUpCompanyInfo',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/dressUpCompanyInfo',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

// This sends the user-edited traits back to API to get new advice a single company
export const updateDressUpAdvice = async (
	data: UpdateDressUpAdviceRequest
): Promise<DressUpPromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/updateDressUpAdvice',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/updateDressUpAdvice',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postMusicalChairsPrompt = async (
	data: MusicalChairsPrompt
): Promise<MusicalChairsPromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/musicalChairsPrompt',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/musicalChairsPrompt',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postDressUpResponse = async (
	data: DressUpResponse
): Promise<DressUpResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/dressUpResponse',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/dressUpResponse',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postMusicalChairsResponse = async (
	data: MusicalChairsResponse
): Promise<MusicalChairsResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/musicalChairsResponse',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/musicalChairsResponse',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postTeeterTotterResponse = async (
	data: TeeterTotterResponse
): Promise<TeeterTotterResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/teeterTotterResponse',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/teeterTotterResponse',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const updateTeeterTotterAdvice = async (
	data: UpdateTeeterTotterAdviceRequest
): Promise<TeeterTotterResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/updateTeeterTotterAdvice',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/updateTeeterTotterAdvice',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postRoundRobinPrompt = async (
	data: RoundRobinPrompt,
	pathURL: string
): Promise<RoundRobinPromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		`ai/roundRobin${pathURL}`,
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				`ai/roundRobin${pathURL}`,
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postRoundRobinResponse = async (
	data: RoundRobinResponse
): Promise<RoundRobinResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/roundRobinResponse',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/roundRobinResponse',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const updateRoundRobinPrompts = async (
	data: UpdateRoundRobinPromptsRequest
): Promise<RoundRobinResponseResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/updateRoundRobinPrompts',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/updateRoundRobinPrompts',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postSimonSaysPrompt = async (
	data: SimonSaysPrompts
): Promise<SimonSaysPromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'randomprompts/simonSays',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'randomprompts/simonSays',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

// This returns the data that populates Section2 of the game
export const postBuildingBlocksPrompt = async (
	data: BuildingBlocksPrompt
): Promise<BuildingBlocksPromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/buildingBlocksPrompt',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/buildingBlocksPrompt',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postOppositeDayPrompt = async (
	data: OppositeDayPrompt
): Promise<OppositeDayPromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/oppositeDayPrompt',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/oppositeDayPrompt',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const postOppositeDayResponse = async (
	data: OppositeDayPrompt
): Promise<OppositeDayPromptResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/oppositeDayPromptResponse',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/oppositeDayPromptResponse',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}

export const updateSimonSaysPersonaIdeaExamples = async (
	data: SimonSaysAiIdeasResponseInput
): Promise<SimonSaysExampleIdeaResponse> => {
	const signed = await getSignedRequest(
		'POST',
		'ai/updateSimonSaysAiIdeas',
		JSON.stringify(data)
	)

	if (signed) {
		return await axios({
			...signed,
			url:
				(process.env.REACT_APP_AWS_API_URL as string) +
				'ai/updateSimonSaysAiIdeas',
			data,
		})
	} else {
		throw Error('Unable to get signed request')
	}
}
